import { Injectable } from '@angular/core';
import { TokensService } from './tokens.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  get isLoggedIn(): boolean {
    return !!(this.tokensService.accessToken && this.userService.user?.id);
  }

  constructor(
    private tokensService: TokensService,
    private userService: UserService
  ) {}

  logout() {
    this.tokensService.removeAccessToken();
    this.userService.clearUser();
  }
}
